module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "updateIndexesButton",
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.updateIndexes()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-signal"
  }), _vm._v(" Update Indexes\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Updates indexes for all model databases")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "deleteAllModelsButton",
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.deleteAllModels()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove"
  }), _vm._v(" Delete all models\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Delete all models")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "setDbPrefixButton",
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.setDbPrefix()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-adjust"
  }), _vm._v(" Set database prefix\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Changes database prefix (for switching areas)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.upgradeModelDatabases()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up"
  }), _vm._v(" Upgrade model databases\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Ensures model databases are upgraded to latest version")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.seedUsers()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" Seed users\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Ensures default user accounts are created, and correct roles and claims assigned")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.upgradeSystemDatabase()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up"
  }), _vm._v(" Upgrade system database\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Ensures system database is upgraded to latest version")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "to": "/admin/tag-categories",
      "tag": "button",
      "disabled": _vm.isBusy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-tags"
  }), _vm._v(" Tag Categories\n                        ")])], 1), _vm._v(" "), _c('p'), _c('header', [_vm._v("Management of node tag categories")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "click": function($event) {
        return _vm.executeCommand()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" Execute command\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Executes a command ")]), _vm._v(" "), _c('p')])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Database Admin")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-69e6cc55", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e6cc55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/db-admin/db-admin-index.vue.html
// module id = 1112
// module chunks = 0